import React from 'react';
import './PetAnimations.css';

export default function DolphinSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#7098B8';
  const lightColor = color ? lighten(color) : '#A0C0D8';
  const darkColor = color ? darken(color) : '#507898';
  const bellyColor = '#D0E0F0';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Body (curved, dynamic pose) */}
      <path
        d="M30 56C36 46 50 40 68 42C86 44 98 54 100 62C102 70 94 76 80 78C66 80 44 76 34 70C24 64 24 66 30 56Z"
        fill={bodyColor}
      />
      {/* Belly */}
      <path
        d="M36 62C42 56 56 52 72 54C88 56 96 62 96 66C96 72 86 76 74 76C58 76 40 72 36 66Z"
        fill={bellyColor}
      />
      {/* Dorsal fin */}
      <path d="M62 42L58 24L68 38Z" fill={bodyColor} />
      <path d="M63 42L60 28L67 38Z" fill={darkColor} opacity="0.3" />
      {/* Tail flukes */}
      <path d="M28 58C20 50 12 48 10 52C8 56 14 58 20 58" fill={bodyColor} />
      <path d="M28 64C20 72 12 74 10 70C8 66 14 64 20 64" fill={bodyColor} />
      {/* Tail connection */}
      <ellipse cx="28" cy="61" rx="6" ry="5" fill={bodyColor} />
      {/* Pectoral flipper */}
      <path d="M66 66C62 72 56 78 52 80C48 82 48 78 52 74C56 70 62 66 66 66Z" fill={darkColor} />
      {/* Head */}
      <ellipse cx="94" cy="60" rx="14" ry="12" fill={bodyColor} />
      {/* Snout (beak) */}
      <path d="M104 58C110 56 116 58 114 60C112 62 108 62 104 62Z" fill={lightColor} />
      {/* Melon (forehead) */}
      <ellipse cx="92" cy="56" rx="8" ry="6" fill={lightColor} opacity="0.3" />
      {/* Eye */}
      <circle cx="98" cy="56" r="3.5" fill="white" />
      <circle cx="99" cy="56" r="2" fill="#1A3050" />
      <circle cx="99.5" cy="55" r="0.8" fill="white" />
      {/* Mouth (friendly smile) */}
      <path d="M104 60C108 62 112 62 114 60" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Blowhole */}
      <ellipse cx="88" cy="50" rx="2" ry="1" fill={darkColor} />
      {/* Water splash hint */}
      <circle cx="86" cy="44" r="1.5" fill="#A0D0F0" opacity="0.5" />
      <circle cx="90" cy="42" r="1" fill="#A0D0F0" opacity="0.4" />
      <circle cx="84" cy="42" r="1" fill="#A0D0F0" opacity="0.3" />
      {/* Body highlight */}
      <ellipse cx="72" cy="50" rx="14" ry="4" fill={lightColor} opacity="0.3" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
